import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiTwitter, FiInstagram, FiYoutube, FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import { API_BASE_URL, BASE_URL,institute_id } from '../config/config';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [settings, setSettings] = useState(null);


  useEffect(() => {
    fetchSiteSettings();
  }, []);

  const fetchSiteSettings = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/site-settings?institute_id=${institute_id}`);
      const data = await response.json();
      if (data.success) {
        setSettings(data.data);
      }
    } catch (error) {
      console.error('Error fetching site settings:', error);
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300 hidden lg:block">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              {settings?.logo ? (
                <>
                  <img 
                    src={`${settings.logo}`}
                    alt={settings.site_name || 'Logo'}
                    className="h-10 w-auto"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.querySelector('.fallback-logo').style.display = 'flex';
                    }}
                  />
                  <div className="fallback-logo w-10 h-10 bg-gradient-to-br from-primary-500 to-purple-600 rounded-lg items-center justify-center" style={{ display: 'none' }}>
                    <span className="text-white font-bold text-xl">R</span>
                  </div>
                </>
              ) : (
                <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-purple-600 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-xl">R</span>
                </div>
              )}
              <div>
              
              </div>
            </div>
            <p className="text-sm text-gray-400">
              {settings?.about_text || 'Your gateway to success in competitive exams. Quality education for aspiring students.'}
            </p>
            <div className="flex space-x-4 mt-4">
              {settings?.facebook && (
                <a href={settings.facebook} target="_blank" rel="noopener noreferrer" className="hover:text-primary-400 transition-colors" aria-label="Facebook">
                  <FiFacebook className="w-5 h-5" />
                </a>
              )}
              {settings?.twitter && (
                <a href={settings.twitter} target="_blank" rel="noopener noreferrer" className="hover:text-primary-400 transition-colors" aria-label="Twitter">
                  <FiTwitter className="w-5 h-5" />
                </a>
              )}
              {settings?.instagram && (
                <a href={settings.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-primary-400 transition-colors" aria-label="Instagram">
                  <FiInstagram className="w-5 h-5" />
                </a>
              )}
              {settings?.youtube && (
                <a href={settings.youtube} target="_blank" rel="noopener noreferrer" className="hover:text-primary-400 transition-colors" aria-label="YouTube">
                  <FiYoutube className="w-5 h-5" />
                </a>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-primary-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-sm hover:text-primary-400 transition-colors">
                  Courses
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm hover:text-primary-400 transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-primary-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-primary-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Popular Categories */}
          <div>
            <h3 className="text-white font-bold mb-4">Popular Categories</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/courses" className="text-sm hover:text-primary-400 transition-colors">
                  Economics
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-sm hover:text-primary-400 transition-colors">
                  Competitive Exams
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-sm hover:text-primary-400 transition-colors">
                  Government Jobs
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm hover:text-primary-400 transition-colors">
                  Latest News
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm hover:text-primary-400 transition-colors">
                  Exam Tips
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              {settings?.address && (
                <li className="flex items-start space-x-3">
                  <FiMapPin className="w-5 h-5 text-primary-400 flex-shrink-0 mt-0.5" />
                  <span className="text-sm">
                    {settings.address}
                  </span>
                </li>
              )}
              {settings?.phone && (
                <li className="flex items-center space-x-3">
                  <FiPhone className="w-5 h-5 text-primary-400 flex-shrink-0" />
                  <a href={`tel:${settings.phone.replace(/\s/g, '')}`} className="text-sm hover:text-primary-400 transition-colors">
                    {settings.phone}
                  </a>
                </li>
              )}
              {settings?.email && (
                <li className="flex items-center space-x-3">
                  <FiMail className="w-5 h-5 text-primary-400 flex-shrink-0" />
                  <a href={`mailto:${settings.email}`} className="text-sm hover:text-primary-400 transition-colors">
                    {settings.email}
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} Brainers Hub. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4 md:gap-6">
              <Link to="/privacy-policy" className="text-sm text-gray-400 hover:text-primary-400 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-conditions" className="text-sm text-gray-400 hover:text-primary-400 transition-colors">
                Terms & Conditions
              </Link>
              <Link to="/refund-policy" className="text-sm text-gray-400 hover:text-primary-400 transition-colors">
                Refund Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

